import defaultWebThankYou from '#themes/default/web/pages/thankYou/thankYou.js';

import cBillingSummary from '#themes/avast/web/components/billingSummary/billingSummary.js';
import cButton from '#themes/avast/web/components/button/button.js';
import cCompanySummary from '#themes/avast/web/components/companySummary/companySummary.js';
import cEmailButton from '#themes/avast/web/components/emailButton/emailButton.js';
import cHeader from '#themes/avast/web/components/header/header.js';
import cInfoBox from '#themes/avast/web/components/infoBox/infoBox.js';
import cInstructionStep from '#themes/avast/web/components/instructionStep/instructionStep.js';
import cOfflineInstructions from '#themes/avast/web/components/offlineInstructions/offlineInstructions.js';
import cOrderSummary from '#themes/avast/web/components/orderSummary/orderSummary.js';
import cProduct from '#themes/avast/web/components/product/product.js';

export default {
	middleware: defaultWebThankYou.middleware,
	components: {
		cBillingSummary,
		cButton,
		cCompanySummary,
		cEmailButton,
		cHeader,
		cInfoBox,
		cInstructionStep,
		cOfflineInstructions,
		cOrderSummary,
		cProduct
	},
	extends: defaultWebThankYou
};
